import React from 'react';
import './engage.scss';
import { t, jt } from 'ttag';

export default function Engage({ data }) {
  return (
    <div className="" id="engage">
      {/* <SmartImage /> */}
      <div className="engage-inner">
        <div className="mainWidth">
          <div className="textHolderEngage">
            <h1 className="title">{t`Customise Your Team Kit`}</h1>
            <div className="innerTextHolder">
              <div>
                <div className="text">{data.header_text}</div>
                <div className="pricepoints text">
                  <div className="subtitle">{jt`Choose Unisport as your Sponsor and Save ${data.unisport_sponsor_discount}%`}</div>

                  <div className="bullet">{`1: ${t`Select Brand, Model and Age`}`}</div>
                  <div className="bullet">{`2: ${t`Select Colors and Quantity`}`}</div>
                  <div className="bullet">{`3: ${t`Choose Unisport as your Sponsor and Other Prints`}`}</div>
                  <div className="bullet">{`4: ${t`Review Order and Confirm`}`}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
